import React from 'react'

const TickerLeagueTitle = ({ title, index, tickerClass }) => {
    let initAniDelay = 1 * `.${index}`

    return (
        <div
            className={`ticker__league_title ${tickerClass}`}
            style={{
                transition: `transform .3s ${initAniDelay}s cubic-bezier(.32,1.07,.53,1.15), opacity .3s ${initAniDelay}s`,
            }}
        >
            <div className="title_wrapper">{title}</div>
        </div>
    )
}

export default TickerLeagueTitle
